import { ReceiptState, ReceiptStateValue } from '@interfaces/receipts';
import { Source } from '@interfaces/source';

export function checkReceiptStateValue(
  source: Source,
  stateValue: ReceiptStateValue,
  receiptsState?: ReceiptState | null
) {
  const sourceState = receiptsState?.source[source];
  return !!sourceState && sourceState.state === stateValue;
}
